import React from 'react';

import {OccupationCollectionBanner} from '@udemy/react-personalized-content';

interface OccupationCollectionBannerComponentProps {
    enableInProductOccupationCollection: boolean;
    isOccupationCollectionPromptDismissed: boolean;
    className?: string;
}

export const OccupationCollectionBannerComponent: React.FC<
    OccupationCollectionBannerComponentProps
> = ({
    enableInProductOccupationCollection,
    isOccupationCollectionPromptDismissed,
    className = 'component-margin',
}) => {
    if (!enableInProductOccupationCollection || isOccupationCollectionPromptDismissed) {
        return null;
    }

    return (
        <div className={className}>
            <OccupationCollectionBanner />
        </div>
    );
};
